import { render, staticRenderFns } from "./BaseTopSectionTitle.vue?vue&type=template&id=36fa4fd6&scoped=true&"
var script = {}
import style0 from "./BaseTopSectionTitle.vue?vue&type=style&index=0&id=36fa4fd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa4fd6",
  null
  
)

export default component.exports